import React, { Fragment } from 'react';
import LocaleCode from 'locale-code';
import DashboardView from 'dashboard/DashboardView.react';
import Field from 'components/Field/Field.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import FlowView from 'components/FlowView/FlowView.react';
import Label from 'components/Label/Label.react';
import Button from 'components/Button/Button.react';
import renderFlowFooterChanges from 'lib/renderFlowFooterChanges';
import styles from 'dashboard/Settings/Settings.scss';
import TextInput from 'components/TextInput/TextInput.react';
import Toggle from 'components/Toggle/Toggle.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import unique from 'lib/unique';
import { Promise } from 'parse';
import history from 'dashboard/history';

const DEFAULT_EMAIL_VERIFICATION_MAIL_SUBJECT = 'Please verify your e-mail for %appname%';
const DEFAULT_EMAIL_VERIFICATION_MAIL_BODY = `Hi,

You are being asked to confirm the e-mail address %email% with %appname%

Click here to confirm it:
%link%`;
const DEFAULT_RESET_PASSWORD_MAIL_SUBJECT = 'Password Reset Request for %appname%';
const DEFAULT_RESET_PASSWORD_MAIL_BODY = `Hi,

You requested a password reset for %appname%.

Click here to reset it:
%link%`;


export default class EmailsSettings extends DashboardView {
  constructor(props) {
    super(props);
    this.section = 'App Settings';
    this.subsection = 'Emails & Hosting';

    this.state = {
      showDeleteModal: false,
    };
  }

  renderForm({
    changes, fields, setField, resetFields,
  }) {
    const { deleted } = changes;
    const langTag = this.props.params.langTag;
    const goBackURL = this.props.location.pathname.replace(`/templates/${langTag}`, '');

    if (!LocaleCode.validateCountryCode(langTag)) {
      history.push(goBackURL);
      return null;
    }

    const country = LocaleCode.getCountryName(langTag);

    const { initialFields } = this.props;
    const isDefault = initialFields.default_templates_locale === langTag;

    const emailTemplatesFields =
      (<Fieldset
        legend={`Email templates - ${country} (${langTag})`}
        description="Customize the emails sent to your users when they manage their account information.">
        <div className={styles.settingsBox}>
          <Field
            label={<Label text="Verification Email Subject" />}
            input={<TextInput
              value={
                deleted ? '' :
                  (
                    changes.email_verification_mail_subject ||
                    (fields.email_templates && (fields.email_templates[langTag] || []).email_verification_mail_subject) ||
                    fields.email_verification_mail_subject ||
                    DEFAULT_EMAIL_VERIFICATION_MAIL_SUBJECT || ''
                  )
              }
              onChange={setField.bind(this, 'email_verification_mail_subject')} />
            } />

          <Field
            label={<Label text="Verification Email Body" />}
            input={<TextInput
              multiline
              height={180}
              value={
                deleted ? '' :
                  (
                    changes.email_verification_mail_body ||
                    (fields.email_templates && (fields.email_templates[langTag] || {}).email_verification_mail_body) ||
                    fields.email_verification_mail_body ||
                    DEFAULT_EMAIL_VERIFICATION_MAIL_BODY || ''
                  )
              }
              onChange={setField.bind(this, 'email_verification_mail_body')} />
            } />

          <Field
            label={<Label text="Password Reset Subject" />}
            input={<TextInput
              value={
                deleted ? '' :
                  (
                    changes.reset_password_mail_subject ||
                    (fields.email_templates && (fields.email_templates[langTag] || {}).reset_password_mail_subject) ||
                    fields.reset_password_mail_subject ||
                    DEFAULT_RESET_PASSWORD_MAIL_SUBJECT || ''
                  )
              }
              onChange={setField.bind(this, 'reset_password_mail_subject')} />
            } />

          <Field
            label={<Label text="Password Reset Email Body" />}
            input={<TextInput
              multiline
              height={160}
              value={
                deleted ? '' :
                  (
                    changes.reset_password_mail_body ||
                    (fields.email_templates && (fields.email_templates[langTag] || {}).reset_password_mail_body) ||
                    fields.reset_password_mail_body ||
                    DEFAULT_RESET_PASSWORD_MAIL_BODY || ''
                  )
              }
              onChange={setField.bind(this, 'reset_password_mail_body')} />
            } />


          {
            !isDefault &&
            <Fragment>
              <div className={styles.hr} />
              {
                // <div style={{ padding: '10px 30px 30px' }}>
                //   <FormButton
                //     color='red'
                //     value='Delete these templates'
                //     onClick={() => {
                //       this.setState({ showDeleteModal: true })
                //     }} />


                // </div>
              }

              <Field
                className="oneliner"
                label={<Label
                  className="oneliner"
                  text="Delete these templates" />}
                input={<Toggle
                  onChange={setField.bind(this, 'deleted')}
                  value={fields.deleted} />} />
            </Fragment>
          }
        </div>
      </Fieldset>);


    // const deleteModal = <FormModal
    //   title='Delete This Email Template'
    //   subtitle='This is an irreversible action!'
    //   type={Modal.Types.DANGER}
    //   open={this.state.showDeleteModal}
    //   submitText='Delete template'
    //   inProgressText={'Deleting\u2026'}
    //   onSubmit={() => {
    //     setField('deleted', true);
    //   }}
    //   onSuccess={(result) => {
    //     history.push(goBackURL)
    //   }}
    //   onClose={() => this.setState({ showDeleteModal: false })}
    // >
    // </FormModal>

    return (
      <div className={[styles.settings_page, 'ShowFooter'].join(' ')}>
        <Toolbar section={this.section} subsection="Templates Localization">
          <Button value="Go Back" onClick={() => history.push(goBackURL)} />
        </Toolbar>
        <div className={styles.holder}>
          {emailTemplatesFields}
        </div>
      </div>
    );
  }

  renderContent() {
    const langTag = this.props.params.langTag;
    const { initialFields } = this.props;

    if (!initialFields) {
      return <Toolbar section={this.section} subsection={this.subsection} />;
    }

    initialFields.deleted = false;

    return (
      <FlowView
        initialFields={initialFields}
        footerContents={({ changes }) => renderFlowFooterChanges(changes, initialFields, userFieldOptions)}
        onSubmit={({ changes, fields, setField }) => {
          const { initialFields } = this.props;

          const isDefault = initialFields.default_templates_locale === langTag;

          const f = (fields.email_templates && fields.email_templates[langTag]) ? fields.email_templates[langTag] : {};

          const defObj = {
            email_verification_mail_subject: DEFAULT_EMAIL_VERIFICATION_MAIL_SUBJECT,
            email_verification_mail_body: DEFAULT_EMAIL_VERIFICATION_MAIL_BODY,
            reset_password_mail_subject: DEFAULT_RESET_PASSWORD_MAIL_SUBJECT,
            reset_password_mail_body: DEFAULT_RESET_PASSWORD_MAIL_BODY,
          };

          const obj = {
            ...defObj,
            ...f,
          };

          const isFirstTemplate = !initialFields.email_templates && !initialFields.default_templates_locale;

          const newTemplate = {
            ...(isFirstTemplate ? { default_templates_locale: 'en-US' } : {}),
            ...(isFirstTemplate ? { ...defObj } : {}),
            ...(isDefault ? { ...obj, ...changes } : {}),
            email_templates: {
              ...(isFirstTemplate ? { 'en-US': obj } : {}),
              ...fields.email_templates,
              [langTag]: { ...obj, ...changes },
            },
          };

          if (!initialFields.email_templates && !initialFields.default_templates_locale) {
            newTemplate.email_templates['en-US'] = obj;
            newTemplate.default_templates_locale = 'en-US';
          }

          if (changes.deleted) {
            delete newTemplate.email_templates[langTag];
          }

          if (changes.deleted) {
            setTimeout(() => {
              const goBackURL = this.props.location.pathname.replace(`/templates/${langTag}`, '');
              history.push(goBackURL);
            }, 2000);
          }

          return this.props.saveChanges(newTemplate).then(({ successes, failures }) => {
            for (const k in successes) {
              setField(k, successes[k]);
            }

            if (Object.keys(failures).length > 0) {
              return { error: Object.values(failures).join(' ') };
            }
          })
            .catch(({ error, failures = {} }) => {
              return { error: unique(Object.values(failures).concat(error)).join(' ') };
            });
        }}
        validate={() => ''}
        renderForm={this.renderForm.bind(this)} />
    );
  }
}

let userFieldOptions = {
  deleted: {
    friendlyName: 'fields and these templates will be deleted',
  },
  email_verification_mail_subject: {
    friendlyName: 'verification email subject',
  },
  email_verification_mail_body: {
    friendlyName: 'verification email body',
  },
  reset_password_mail_subject: {
    friendlyName: 'password reset subject',
  },
  reset_password_mail_body: {
    friendlyName: 'password reset email body',
  },
};
